<template>
    <q-layout view="hHh lpR fFf" style="height: 100vh">
        <q-page-container
            class="fit row wrap justify-center items-center content-center"
        >
            <q-card bordered style="width: 600px">
                <img
                    src="../assets/d_tr1.png"
                    style="width: 300px; height: 300px; margin: auto"
                />

               

                <q-card-section>
                    
                    
                    <q-input
                        outlined
                        v-model="date"
                        mask="date"
                        label="Select DOB"
                    >
                        <template v-slot:append>
                            <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy
                                    cover
                                    transition-show="scale"
                                    transition-hide="scale"
                                >
                                    <q-date v-model="date">
                                        <div
                                            class="row items-center justify-end"
                                        >
                                            <q-btn
                                                v-close-popup
                                                label="Close"
                                                color="primary"
                                                flat
                                            />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>

                    <q-input
                        v-model="mobileNumber"
                        label="Mobile Number"
                        outlined
                        style="width: 100%; margin-top: 10px"
                    ></q-input>

                    <q-input
                        v-if="otpSent"
                        v-model="otpcode"
                        label="Code"
                        outlined
                        style="width: 100%; margin-top: 10px"
                    ></q-input>

                    <q-input
                        v-if="otpSent"
                        v-model="password"
                        label="Enter New Password"
                        outlined
                        type=""
                        style="width: 100%; margin-top: 10px"
                    ></q-input>


                    <q-chip v-if="otpSent" dense icon="directions" style="margin: 10px auto;">
                        Code is sent by sms. Please check the inbox of the Phone
                    </q-chip>

                </q-card-section>

                
                <q-separator></q-separator>

                <q-card-section>
                    <q-btn
                        :label="!otpSent ? 'Send code' : 'Resend code'"
                        color="indigo"
                        @click="sendOtp"
                    ></q-btn>

                

                    <q-btn
                        label="Change Password"
                        color="indigo"
                        @click="changePassord"
                        style="margin-left: 5px"
                        :disable="!otpSent"
                        v-if="otpSent"
                    ></q-btn>

                    <q-btn
                        label="Back"
                        color="indigo"
                        href="#/login"
                        style="margin-left: 5px"
                    ></q-btn>
                </q-card-section>
            </q-card>
        </q-page-container>
    </q-layout>
</template>

<script>
import axios from "axios";
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import { Notify } from "quasar";

export default {
    setup() {
        const date = ref();
        const mobileNumber = ref();
        const password = ref();
        const otpcode = ref();
        const otpSent = ref(false);

        const router = useRouter();
        const changePassord = async () => {
            try {
                const { data } = await axios.post(
                    "https://cycles.nlf.clinic/ws-nlp/public/security/reset-password",
                    {
                        phone: mobileNumber.value,
                        password: password.value,
                        dob: date.value,
                        otp: otpcode.value
                    }
                );
                Notify.create({
                    type: "positive",
                    message: "Password Changed",
                });

                router.push({ path: '/login', hash: '#team' })

            } catch (err) {
                if (err.response.status == 404) {
                    Notify.create({
                        type: "negative",
                        message: err.response.data.message,
                    });
                }

                if (err.response.status == 500) {
                    Notify.create({
                        type: "negative",
                        message: "Some error occured",
                    });
                }
            }
        };

        const sendOtp = async () => {
            try {
                if(mobileNumber.value != null && mobileNumber.value.trim() != ''
                        && date.value != null && date.value.trim() != '') {
                    const { data } = await axios.post(
                        "https://cycles.nlf.clinic/ws-nlp/public/security/send-otp",
                        {
                            phone: mobileNumber.value,
                            dob: date.value,
                        }
                    );

                    otpSent.value = true;
                    
                } else {
                     Notify.create({
                        type: "negative",
                        message: "Mobile number / DOB is required",
                    });
                }
            } catch (err) {
                if (err.response.status == 404) {
                    Notify.create({
                        type: "negative",
                        message: err.response.data.message,
                    });
                }

                if (err.response.status == 500) {
                    Notify.create({
                        type: "negative",
                        message: "Some error occured",
                    });
                }
            }
        };

        return {
            date,
            mobileNumber,
            password,
            otpcode,
            otpSent,
            changePassord,
            sendOtp
        };
    },
};
</script>

<style scoped>
.q-layout {
    background-image: url(../assets/d_nl.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
